<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <nav-bar left-arrow :title="$t('互转')" bgColor="#000000" />
    <div-padding padding="4vw">
      <div-card height="35vw" padding='3vw'>
        <div-height height='5vw' />
        <div-text color='#fff' align="center" size='7vw'>
          {{ usdt }}
        </div-text>
        <div-text color='#999' align="center" size='3.5vw'>{{ $t('可用') }} ACT</div-text>
      </div-card>
      <div-height height='6vw' />
      <!-- 输入框开始 -->
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' :formatter="formatter" clearable type="number" v-model='num'
            :placeholder='$t("请输入互转数量")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t("互转数量") }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='address' :placeholder='$t("请输入接收地址")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t("接收地址") }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />

      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <div-flex left>
            <div-width width='24vw'>
              <div-text size='4vw' color='#FFFFFF'>{{ $t('手续费') }}{{ info.subgift_fee }}%</div-text>
            </div-width>
            <div-text size='4vw' color='#CEB082'>{{ (info.subgift_fee / 100 * num).toFixed(4) }}</div-text>
          </div-flex>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable readonly :value='(num * 1 + (info.subgift_fee / 100 * num)).toFixed(4)'
            :placeholder='$t("自动计算")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('实际支付') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='8vw' />
      <div-btn @click.native="one()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
        <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
      </div-btn>
      <div-height height='20vw' />
      <div-padding padding="4vw 0">
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('互转说明') }}</div-text>
        </div-flex>
      </div-padding>
      <div-text color='#999' size='4vw'>{{ info.subgift_rule }}</div-text>
    </div-padding>
    <van-popup class="popupcode" v-model="show_code" style="width: 76%;top:40%;" closeable>
      <div class="content">
        <p>{{ $t('交易密码') }}</p>
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading"
          @click="pay">{{ $t('确定') }}</van-button>
      </div>
    </van-popup>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        active: 0,
        phone: "",
        info: {},
        num: "",
        address: "",
        usdt: "",
        show_code: false,
        password: "",
        loading: false,
      }
    },
    created() {
      this.get_info()
    },
    methods: {
      pay() {
        if (!this.password) return this.$toast(this.$t("请输入交易密码"))
        if (this.loading == true) {
          return this.$toast(this.$t("请勿重复提交"))
        }
        this.loading = true
        this.$post({
          url: "/api/v1/user/subgift",
          data: {
            amount: this.num,
            account: this.address,
            trade_password: this.password,
          },
          success: (res) => {
            this.password = ""
            this.num = ""
            this.address = ""
            this.show_code = false
            this.$toast(this.$t("互转成功"))
            this.get_info()
            setTimeout(() => {
              this.loading = false
            }, 2000)
          },
          tip: () => {
            this.password = ""
            this.show_code = false
            setTimeout(() => {
              this.loading = false
            }, 2000)
          },
        })
      },
      one(id) {
        if (!this.num) return this.$toast(this.$t("请输入互转数量"))
        if (!this.address) return this.$toast(this.$t("请输入接收地址"))
        this.show_code = true
      },
      formatter(value) {
        // Remove any non-numeric characters
        value = value.replace(/[^0-9.]/g, "")

        // Limit to two decimal places
        const decimalIndex = value.indexOf(".")
        if (decimalIndex !== -1) {
          value = value.slice(0, decimalIndex + 5)
        }

        return value
      },
      get_info() {
        this.$get({
          url: "/api/v1/user/info",
          success: (res) => {
            this.usdt = res.data.act
          },
          tip: () => { },
        })
        this.$get({
          url: "/api/v1/financial",
          success: (res) => {
            this.info = res.data
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped>
  /deep/.van-field__control {
    color: #fff !important;
    font-size: 4vw !important;
  }
</style>